module.exports = __webpack_public_path__ + "static/media/selection.2a470f03.png";